<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <b-form @submit.stop.prevent="onSubmit">
            <div class="clearfix">
                <div class="col-md-12">
                    <div class="row clearfix">
                        <div class="col-md-6">
                            <b-form-group id="effective_start_date-group" label="Effective Start Date"
                                label-for="effective_start_date" class="required-field">
                                <b-input-group class="mb-3">
                                    <b-form-input id="effective_start_date" name="effective_start_date"
                                        v-model="fdata.effective_start_date"
                                        v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text"
                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                        :state="validateState('effective_start_date')"
                                        aria-describedby="effective_start_date-feedback"
                                        data-vv-as="Effective Start Date" :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                        <!-- Sifat: 07-07-2025 Check GF Module -->
                                        <b-form-datepicker id="day_one" button-only right locale="en-US"
                                            v-model="date_start"
                                            @input="fdata.effective_start_date = formatDate(date_start)" :disabled="readonly">
                                        </b-form-datepicker>
                                        <!-- Sifat: 07-07-2025 Check GF Module -->
                                    </b-input-group-append>
                                    <b-form-invalid-feedback id="effective_start_date-feedback">{{
                                        veeErrors.first('effective_start_date') }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </div>
                        <!-- <div class="col-md-6"></div> -->

                        <div class="col-md-6">
                            <b-form-group id="proposed_contribution_amount-group"
                                label="Actuarial Proposed Contribution Amount" class="required-field"
                                label-for="proposed_contribution_amount">
                                <b-form-input id="proposed_contribution_amount" name="proposed_contribution_amount"
                                    v-model="fdata.proposed_contribution_amount"
                                    v-validate="{ required: true, regex: /^[0-9]+(\.[0-9]+)?$/ }"
                                    :state="validateState('proposed_contribution_amount')"
                                    aria-describedby="proposed_contribution_amount-feedback"
                                    data-vv-as="Proposed Contribution Amount" :disabled="readonly"></b-form-input>
                                <b-form-invalid-feedback id="proposed_contribution_amount-feedback">{{
                                    veeErrors.first('proposed_contribution_amount') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <!-- <div class="col-md-6"></div> -->

                        <div class="col-md-12">
                            <b-form-group id="detail_and_description-group" label="Detail and Description" class=""
                                label-for="detail_and_description">
                                <b-form-textarea id="detail_and_description"
                                    :state="validateState('detail_and_description')" name="detail_and_description"
                                    v-model="fdata.detail_and_description" v-validate="{}" rows="3" max-rows="6"
                                    no-resize aria-describedby="detail_and_description-feedback"
                                    data-vv-as="Detail and Description" :disabled="readonly"></b-form-textarea>
                                <b-form-invalid-feedback id="detail_and_description-feedback">{{
                                    veeErrors.first('detail_and_description') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>

                        <div class="col-md-12" v-if="!readonly">
                            <file-component ref="fileinput" :labelname="this.attachment" :accept="this.accept"
                                :multiple="this.multiple" v-on:childToParent="listReturnAttachment"></file-component>
                        </div>

                        <div class="col-md-6">
                            <b-form-group id="actuarial_type-group" label="Actuarial Type" label-for="actuarial_type"
                                class="required-field">
                                <b-form-select name="actuarial_type" class='form-control' v-model="fdata.actuarial_type"
                                    :options="actuarial_type_list" v-validate="{ required: true }"
                                    :state="validateState('actuarial_type')" aria-describedby="actuarial_type-feedback"
                                    data-vv-as="Actuarial Type" :disabled="readonly">
                                </b-form-select>
                                <b-form-invalid-feedback id="actuarial_type-feedback">{{
                                    veeErrors.first('actuarial_type') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <!-- <div class="col-md-6"> </div> -->

                        <!--Start: Sifat: 07-07-2025 Check GF Module -->
                        <template v-if="fdata.actuarial_type == 1">
                            <div class="col-md-6">
                                <b-form-group id="salary_basis-group" label="Salary Basis" label-for="salary_basis"
                                    class="" :class="{ 'required-field': fdata.actuarial_type == 1 }">
                                    <b-form-select name="salary_basis" class="form-control" v-model="fdata.salary_basis"
                                        :options="salary_basis_list"
                                        v-validate="fdata.actuarial_type == 1 ? { required: true } : {}"
                                        :state="validateState('salary_basis')" aria-describedby="salary_basis-feedback"
                                        data-vv-as="Salary Basis" :disabled="readonly">
                                    </b-form-select>

                                    <b-form-invalid-feedback id="salary_basis-feedback">{{
                                        veeErrors.first('salary_basis') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <!-- <div class="col-md-6"> </div> -->

                            <div class="col-md-6">
                                <b-form-group id="actuarial_report_rate-group" label="Actuarial Report Rate"
                                    label-for="actuarial_report_rate" class="" :class="{ 'required-field': fdata.actuarial_type == 1 }">
                                    <b-form-input id="actuarial_report_rate" name="actuarial_report_rate"
                                        v-model="fdata.actuarial_report_rate"
                                        v-validate="fdata.actuarial_type == 1 ? { required: true, regex: /^[0-9]+(\.[0-9]+)?$/ } : {}"
                                        :state="validateState('actuarial_report_rate')"
                                        aria-describedby="actuarial_report_rate-feedback"
                                        data-vv-as="Actuarial Report Rate" :disabled="readonly">
                                    </b-form-input>

                                    <b-form-invalid-feedback id="actuarial_report_rate-feedback">{{
                                        veeErrors.first('actuarial_report_rate') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group id="monthly_contribution_rate-group" label="Monthly Contribution Rate"
                                    label-for="monthly_contribution_rate" class="" :class="{ 'required-field': fdata.actuarial_type == 1 }">
                                    <b-form-input id="monthly_contribution_rate" name="monthly_contribution_rate"
                                        v-model="fdata.monthly_contribution_rate"
                                        v-validate="fdata.actuarial_type == 1 ? { required: true, regex: /^[0-9]+(\.[0-9]+)?$/ } : {}"
                                        :state="validateState('monthly_contribution_rate')"
                                        aria-describedby="monthly_contribution_rate-feedback"
                                        data-vv-as="Monthly Contribution Rate" :disabled="readonly">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="monthly_contribution_rate-feedback">{{
                                        veeErrors.first('monthly_contribution_rate') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                        </template>
                        <!-- End: Sifat: 07-07-2025 Check GF Module -->



                        <div class="col-md-6">
                            <b-form-group id="effective_end_date-group" label="Effective End Date"
                                label-for="effective_end_date" :class="{ 'required-field': fdata.actuarial_type == 2 }">
                                <b-input-group class="mb-3">
                                    <b-form-input id="effective_end_date" name="effective_end_date"
                                        v-model="fdata.effective_end_date"
                                        v-validate="fdata.actuarial_type == 2 ? { required: true, date_format: 'yyyy-mm-dd' } : {}"
                                        :state="fdata.effective_end_date && fdata.effective_start_date && fdata.effective_end_date < fdata.effective_start_date ? false : validateState('effective_end_date')"
                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                        aria-describedby="effective_end_date-feedback"
                                        data-vv-as="Effective End Date" :disabled="readonly"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker id="day_one" button-only right locale="en-US"
                                            v-model="date_end" @input="fdata.effective_end_date = formatDate(date_end)" :disabled="readonly">
                                        </b-form-datepicker>
                                    </b-input-group-append>
                                    <b-form-invalid-feedback id="effective_end_date-feedback">
                                        <template v-if="fdata.effective_end_date && fdata.effective_start_date && fdata.effective_end_date < fdata.effective_start_date">Effective End Date must be equal to or later than Effective Start Date.</template>
                                        <template v-else>{{ veeErrors.first('effective_end_date') }}</template>
                                    </b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </div>                        
                        <div class="col-md-6"></div>

                    </div>

                </div>

                <div class="col-md-12 float-right">
                    <div class="col-md-12 text-center mt-5" v-if="!readonly">
                        <b-button type="submit" class="btn-primary" variant="success"> {{ data ? 'Update' : 'Save' }} </b-button>
                    </div>
                </div>
            </div>

        </b-form>
    </b-overlay>
</template>

<script>
    export default {
        mounted() {
            if (this.data) {
                this.fdata.effective_start_date = this.data.effective_date;
                this.fdata.proposed_contribution_amount = this.data.amount;
                this.fdata.detail_and_description = this.data.details;
                this.fdata.actuarial_type = this.data.actuarial_type;
                this.fdata.salary_basis = this.data.salary_base;
                this.fdata.actuarial_report_rate = this.data.report_rate;
                this.fdata.monthly_contribution_rate = this.data.monthly_rate;
                this.fdata.effective_end_date = this.data.effective_end_date;
                this.date_start = this.fdata.effective_start_date; // Sifat: 07-07-2025 Check GF Module
                this.date_end = this.fdata.effective_end_date; // Sifat: 07-07-2025 Check GF Module
            }
        },
        props: ['data', 'readonly'],
        data() {
            return {
                showoverlay: false,
                //Start: Sifat: 07-07-2025 Check GF Module
                fdata: {
                    type_of_run: 1,
                    actuarial_type: null,
                    salary_basis: null,
                    actuarial_report_rate: null,
                    monthly_contribution_rate: null,
                    detail_and_description: null
                },

                actuarial_type_list: [
                    { value: 1, text: "Rate Based" },
                    { value: 2, text: "Amount Based" },
                ],
                //End: Sifat: 07-07-2025 Check GF Module
                salary_basis_list: [
                    { value: 1, text: "Basic Salary" },
                    { value: 2, text: "Gross Salary" },
                ],

                // Start: Rejwan: 25-05-2025 Actuarial Management
                accept: ".jpg, .png, .gif, .pdf , .doc , .docx",
                attachment: 'Attachments',
                multiple: true,
                attachment: 'Upload File',
                document: null,
                // End: Rejwan: 25-05-2025 Actuarial Management
                date_start: null, // Sifat: 07-07-2025 Check GF Module
                date_end: null // Sifat: 07-07-2025 Check GF Module
            }
        },

        //Start: Sifat: 07-07-2025 Check GF Module
        watch: {
            'fdata.actuarial_type'(newVal) {
                this.$nextTick(() => {
                    if (newVal == 1) {
                        this.$validator.attach({ name: 'salary_basis' });
                        this.$validator.attach({ name: 'actuarial_report_rate' });
                        this.$validator.attach({ name: 'monthly_contribution_rate' });

                        this.$validator.validate('salary_basis');
                        this.$validator.validate('actuarial_report_rate');
                        this.$validator.validate('monthly_contribution_rate');
                    } else if (newVal == 2) {
                        this.$validator.attach({ name: 'effective_end_date' });
                        this.$validator.validate('effective_end_date');
                    }
                });
            }
        },
        //End: Sifat: 07-07-2025 Check GF Module



        methods: {
            // Start: Rejwan: 25-05-2025 Actuarial Management
            // listReturnAttachment:function (data) {},
            listReturnAttachment: function (data) {
                this.document = data;
            },
            // End: Rejwan: 25-05-2025 Actuarial Management


            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            onSubmit(e) {
                // Start: Rejwan: 25-05-2025 Actuarial Management
                if (!this.checkNet()) return false;
                if (this.fdata.effective_end_date && this.fdata.effective_start_date && this.fdata.effective_end_date < this.fdata.effective_start_date) {
                    return; // or show a toast
                }
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata)) {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        // if(nm == 'actuarial_type' && fval == 1 && (nm == 'salary_basis' || nm == 'actuarial_report_rate' || )) {
                        //     fdata.salary_basis
                        // }
                        formData.append(nm, fval);
                    }


                    if (this.document && this.document.length) {
                        this.document.forEach((file, index) => {
                            formData.append('document[]', file);
                        });
                    } else {
                        formData.append('document', '');
                    }


                    let url;
                    if (this.data) {
                        formData.append('id', this.data.id);
                        url = this.$api_url + '/gf/update-acturial';
                    } else {
                        url = this.$api_url + '/gf/save-acturial';
                    }

                    // axios.post(this.$api_url +'/gf/save-acturial', formData)
                    axios.post(url, formData)
                        .then(function (response) {
                            if (response.data.success == true) {
                                this.$emit('listReturn', response.data);
                            } else if (response.data.warning == true) {
                                this.$bvModal.msgBoxConfirm(response.data.message, {
                                    title: 'Confirm Revision',
                                    size: 'md',
                                    buttonSize: 'sm',
                                    okVariant: 'secondary',
                                    okTitle: 'YES',
                                    cancelTitle: 'NO',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true
                                })
                                .then(value => {
                                    if (value) {
                                        formData.append('confirmed', 1);
                                        axios.post(url, formData)
                                            .then(function (res2) {
                                                if (res2.data.success == true) {
                                                    this.$emit('listReturn', res2.data);
                                                } else {
                                                    this.$bvToast.toast(res2.data.message, {
                                                        title: `Error`,
                                                        variant: 'danger',
                                                        solid: true
                                                    });
                                                }
                                            }.bind(this));
                                    }
                                });
                            } else {
                                this.$bvToast.toast(response.data.message, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });
                            }
                        }.bind(this))
                        .catch(function (error) {
                            let message = 'Something went wrong.';
                            if (error.response && error.response.data) {
                                if (error.response.data.message) {
                                    message = error.response.data.message;
                                } else if (error.response.data.error) {
                                    message = error.response.data.error;
                                }
                            }
                            this.$bvToast.toast(message, {
                                title: 'Error!',
                                variant: 'danger',
                                solid: true
                            });
                        }.bind(this))
                });

                // End: Rejwan: 25-05-2025 Actuarial Management
            },
            // Sifat: 07-07-2025 Check GF Module
            formatDate(date) {
                if (!date) return '';
                const d = new Date(date);
                const yyyy = d.getFullYear();
                const mm = ('0' + (d.getMonth() + 1)).slice(-2);
                const dd = ('0' + d.getDate()).slice(-2);
                return `${yyyy}-${mm}-${dd}`;
            }
            // Sifat: 07-07-2025 Check GF Module

        },
        created: function () { },
        computed: {},

    }
</script>
